/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')
const LargeGearItem = require('./LargeGearItem')
const LargeCustomProductItem = require('./LargeCustomProductItem')
const DomHelper = require('../../../../client/clientjs/dom-helper.js')

class GearsByCategory extends React.Component {
  constructor(props) {
    super(props)
    const { gears } = props
    this.state = {
      gears: gears || [],
      shownCategoryIds: {},
    }
  }

  componentWillMount() {
    const { gears } = this.props
    if (gears && gears.length > 0) {
      this.setState({ shownCategoryIds: { [gears[0].id]: true } })
    }
  }

  render() {
    const { gears, shownCategoryIds } = this.state

    return (
      <div>
        <div className="has-margin-bottom-medium">
          <div className="content">
            {gears.map((category, index, all) => (
              <span key={`category-anchor-link-${category.id}`}>
                {index > 0 && index < all.length && <span>&nbsp;&bull; </span>}
                <a
                  href={`#best-gear-category-${category.id}`}
                  onClick={e => {
                    e.preventDefault()
                    DomHelper.scrollToTarget(document.scrollingElement, `#best-gear-category-${category.id}`)
                  }}
                >
                  {category.name}
                </a>
              </span>
            ))}
          </div>
          {gears.map(category => (
            <div
              key={category.id}
              id={`best-gear-category-${category.id}`}
              className={`collapsible-container ${shownCategoryIds[category.id] ? '' : 'is-collapsed'}`}
            >
              <button
                type="button"
                className="button is-white media pointer-on-hover"
                onClick={() =>
                  this.setState(prevState => ({
                    shownCategoryIds: {
                      ...prevState.shownCategoryIds,
                      [category.id]: !prevState.shownCategoryIds[category.id],
                    },
                  }))
                }
              >
                <figure className="media-left">
                  <p className="image is-24x24">
                    <img src={category.iconUrl} alt={category.name} title={category.name} />
                  </p>
                </figure>
                <div className="media-content">
                  <h3 className="is-size-6 has-text-weight-bold has-text-primary-blue">
                    {`${category.name ? category.name : 'Others'} (${category.content.length})`}
                  </h3>
                </div>
                <span className="icon has-margin-left-small">
                  <i className={`fas fa-caret-${shownCategoryIds[category.id] ? 'up' : 'down'}`} />
                </span>
              </button>
              <div>
                <div className="is-horizontal-scroll collapsible-content">
                  <div className="columns is-mobile is-multiline horizontal-scroll-container is-variable is-1 has-padding-top-small has-padding-bottom-medium">
                    {category.content.map(gear => (
                      <div
                        key={`${gear.type}-${gear.elt.productArticleId || gear.elt.id}`}
                        className="column is-6-mobile is-3-tablet"
                      >
                        {gear.type === 'productArticle' && (
                          <LargeGearItem
                            gear={gear.elt}
                            productCategory={{ ...category, icon: { url_300: category.iconUrl } }}
                          />
                        )}
                        {gear.type === 'customProduct' && (
                          <LargeCustomProductItem
                            gear={gear.elt}
                            productCategory={{ ...category, icon: { url_300: category.iconUrl } }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

GearsByCategory.propTypes = {
  gears: PropTypes.array,
}

GearsByCategory.defaultProps = {
  gears: [],
}

module.exports = GearsByCategory
